import { render, staticRenderFns } from "./receipt-tip-table.vue?vue&type=template&id=370fa630&scoped=true"
import script from "./receipt-tip-table.vue?vue&type=script&lang=js"
export * from "./receipt-tip-table.vue?vue&type=script&lang=js"
import style0 from "./receipt-tip-table.vue?vue&type=style&index=0&id=370fa630&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370fa630",
  null
  
)

export default component.exports